import { render, staticRenderFns } from "./BookedItemDetails.vue?vue&type=template&id=4b9f4542&scoped=true"
import script from "./BookedItemDetails.vue?vue&type=script&lang=ts"
export * from "./BookedItemDetails.vue?vue&type=script&lang=ts"
import style0 from "./BookedItemDetails.vue?vue&type=style&index=0&id=4b9f4542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9f4542",
  null
  
)

export default component.exports